import React, { memo } from 'react';
import Icon from '../Icons';
import { ApprovementStatus } from '../DatatableColumns';
import DocumentActionButtons from './DocumentActionButtons';

const DocumentRow = memo(
  ({ item, handleButtonClick, parentId, permitedActions, canMoveFile, directoryNodes, handleMoveDocument }) => {
    return (
      <tr>
        <td className="text-start align-middle flex-grow-1 text-truncate">
          <Icon icon="document" className="icon-size mr-2" style={{ width: '15px', height: '15px' }} />
          <span className="flex-grow-1" style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
            {item.fileInfo?.filename}
          </span>
        </td>
        <td className="text-center align-middle">{item.createdAt}</td>
        <td className="text-center align-middle">
          <ApprovementStatus status={item.status} />
        </td>
        <td className="text-center align-middle">
          <div className="custom-dropdown__container">
            <DocumentActionButtons
              handleButtonClick={handleButtonClick}
              parentId={parentId}
              item={item}
              permitedActions={permitedActions}
              canMoveFile={canMoveFile}
              directoryNodes={directoryNodes}
              handleMoveDocument={handleMoveDocument}
            />
          </div>
        </td>
      </tr>
    );
  }
);

export default DocumentRow;
